import PropTypes from "prop-types";
import React, { useState } from "react";
import {
  Modal,
  ModalBody,
  ModalHeader,
  Input,
  Label,
  Button,
  Alert,
} from "reactstrap";
import Loader from "./Loader";
import { useSelector, useDispatch } from "react-redux";
import { resetDeleteStatus } from "../../store/actions";
import { Trans, useTranslation } from "react-i18next";

const DeleteTeamModal = ({
  show,
  onDeleteClick,
  onCloseClick,
  teamToDelete,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const { emailAddress } = teamToDelete;

  const [textInput, setTextInput] = useState("");

  const { status, error } = useSelector((state) => ({
    status: state.Team.deleteStatus,
    error: state.Team.deleteError,
  }));

  const handleTextInputChange = (e) => {
    setTextInput(e.target.value);
  };

  const handleConfirmDelete = () => {
    onDeleteClick();
  };

  const handleCloseModal = () => {
    setTextInput("");
    onCloseClick();
  };

  const handleDeleteSuccess = () => {
    setTimeout(() => {
      dispatch(resetDeleteStatus());
      handleCloseModal();
    }, 1500);
  };

  return (
    <Modal
      isOpen={show}
      toggle={handleCloseModal}
      centered={true}
      className="delete-client-modal"
    >
      <ModalHeader toggle={handleCloseModal}>
        <div className="mt-2 text-center">
          <h4>{t("team.deleteModal.title")}</h4>
        </div>
      </ModalHeader>
      <ModalBody className="py-3 px-5">
        {error && (
          <Alert color="danger" className="text-center fw-semibold">
            {error}
          </Alert>
        )}
        <div className="d-flex flex-column">
          <p>
            <Trans
              i18nKey="team.deleteModal.message"
              values={{ email: emailAddress }}
              components={{ strong: <strong /> }}
            />{" "}
            <strong>{t("team.deleteModal.cannotUndo")}</strong>
          </p>
          <ul>
            <li>
              <strong>{emailAddress}</strong>
            </li>
          </ul>
          <p className="mt-3">{t("team.deleteModal.typeToConfirm")}</p>
          <Label htmlFor="deleteInput">
            <Input
              type="text"
              placeholder={t("team.deleteModal.emailPlaceholder")}
              onChange={handleTextInputChange}
              value={textInput}
            />
          </Label>
          <div className="d-flex gap-2 justify-content-end mt-4">
            <Button
              type="button"
              color={status === "success" ? "success" : "danger"}
              disabled={
                status === "loading" ||
                status === "success" ||
                textInput !== emailAddress
              }
              onClick={handleConfirmDelete}
            >
              {status === "loading" ? (
                <Loader size="sm"></Loader>
              ) : status === "success" ? (
                <>
                  {t("team.deleteModal.successful")}
                  {handleDeleteSuccess()}
                </>
              ) : (
                t("common.actions.delete")
              )}
            </Button>
            <Button
              type="button"
              className="text-primary"
              color="light"
              onClick={handleCloseModal}
            >
              {t("common.actions.cancel")}
            </Button>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

DeleteTeamModal.propTypes = {
  onCloseClick: PropTypes.func,
  onDeleteClick: PropTypes.func,
  show: PropTypes.any,
  teamToDelete: PropTypes.object,
};

export default DeleteTeamModal;
